import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	aiNote: {
		backgroundColor: colors.purple[50],
		borderRadius: 12,
		padding: "14px 16px",
		display: "flex",
		alignItems: "flex-start",
		gap: 12
	},
	aiNoteIconBox: {
		width: 28,
		height: 28,
		borderRadius: 8,
		backgroundColor: colors.purple[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	aiNoteIcon: {
		width: 18,
		height: 18,
		"& path": {
			fill: colors.purple[700]
		}
	},
	aiNoteText: {
		fontSize: "13.5px",
		fontWeight: 400,
		lineHeight: 1.5,
		color: colors.purple[900]
	},
	summaryLabel: {
		fontSize: 13,
		fontWeight: 400,
		color: colors.gray[500]
	},
	limparLink: {
		fontSize: 13,
		fontWeight: 800,
		color: colors.purple[700],
		cursor: "pointer"
	}
}))

export default useStyles
